import React from "react";
import PropTypes from "prop-types";
import "./styles.scss";
//import { GenerateCodeUpdated } from "..";
import { Select } from "antd";
import { GetIconByName } from "../../../config/icon";

/* props description goes here
 lable= { string - isRequired}
 iconName = { string - isRequired }
 mainLayerOutOption = { Ex: flex-row / flex-column }
*/

const Option = Select;

const Index = ({ data, onChange }) => {
  let inputElement = null;

  inputElement = (
    <>
      <Select
        className={`sbw__selectBox ${data?.size}`}
        placeholder={data?.placeholder}
        loading={data?.loading}
        defaultValue={data?.defaultValue}
        onChange={onChange}
        disabled={data?.disabled}
      >
        {data &&
          data?.elementConfig &&
          data?.elementConfig.options.map((option) => (
            <Option key={option?.value} value={option.value}>
              {option?.displayValue}
            </Option>
          ))}
      </Select>
    </>
  );
  return (
    <div
      className={`d-flex select-box-warpper
        ${data?.mainLayerStyles} `}
    >
      {data?.label && (
        <div className={`txt-label`}>
          {data?.label}
          {data?.iconName && (
            <span className={"sbw__title-icon"}>
              {GetIconByName(data?.iconName)}
            </span>
          )}
          {data?.isRequired && <b>*</b>}
        </div>
      )}

      {data?.lableConfig && (
        <div className={`sbw__title d-flex flex-row justify-content-between`}>
          {data?.lableConfig}
          {data?.topConfigName && (
            <div className={"sbw__configName"}>{data?.topConfigName}</div>
          )}
        </div>
      )}
      <>{inputElement}</>
      {data?.bottomMessage && (
        <div className={"sbw__bottom-message"}>{data?.bottomMessage}</div>
      )}

      {/*---- error goes here -----*/}
      {data &&
        data?.validation &&
        data?.validation.required &&
        data?.touched && (
          <>
            {/*---- filed is required -----*/}
            {data?.validation.required && !data?.value && (
              <div className="sbw__statusCode">
                You can't keep this as empty
              </div>
            )}

            {/*----  invalid data-----*/}
            {data?.value && data?.invalidReason && (
              <div className="sbw__statusCode">{data?.invalidReason}</div>
            )}
          </>
        )}

      {/* {data.isConfig && (
        <div className={"sbw__generateCode"}>
          <GenerateCodeUpdated
            data={{
              mainLayerStyles:
                " justify-content-between " + " align-items-center ",
              message: "Automatically generate unique code",
              isActive: data.isActive,
              isConfig: data.confiActive,
            }}
          />
        </div>
      )} */}
      {data?.configName && (
        <div className={"sbw__configName"} onClick={data?.configOnclick}>
          {data?.configName}
        </div>
      )}
    </div>
  );
};

Index.propTypes = {
  lable: PropTypes.string,
  size: PropTypes.string,
};

Index.defaultProps = {
  lable: "Unkown",
  iconName: "Unkown",
};

export default Index;
